import {ReferralsTable} from '@widgets/referral';

export const ReferralsPage = () => <ReferralsTable />;
